import type {Transfer} from "@/services/transfers.service";

export interface TransferApiResponse {
  id: string;
  initiator_user_id: string;
  from_account_id: string;
  to_user_id: string;
  to_account_id: string;
  amount_cents: number;
  currency: string;
  fee_cents: number;
  net_amount_cents: number;
  status: string;
  idempotency_key: string;
  completed_at: string | null;
  created_at: string;
  updated_at: string;
  note?: string;
}

export const toTransfer = (raw: TransferApiResponse): Transfer => ({
  id: raw.id,
  initiatorUserId: raw.initiator_user_id,
  fromAccountId: raw.from_account_id,
  toUserId: raw.to_user_id,
  toAccountId: raw.to_account_id,
  amountCents: raw.amount_cents,
  currency: raw.currency,
  feeCents: raw.fee_cents,
  netAmountCents: raw.net_amount_cents,
  status: raw.status as Transfer["status"],
  idempotencyKey: raw.idempotency_key,
  completedAt: raw.completed_at,
  createdAt: raw.created_at,
  updatedAt: raw.updated_at,
  note: raw.note,
});
